import { CarouselDirections } from '../../consts';

export const container = ({ cursorDirection }) => ({
    width: '2.5rem',
    height: '3.9375rem',
    willChange: 'transform',
    transition: 'cubic-bezier(0.4, 0.0, 0.2, 1) transform 0.3s',
    transform: `rotate(${cursorDirection === CarouselDirections.RIGHT ? '0deg' : '180deg'})`,
});
